import Head from 'next/head'
import { MapContainer, TileLayer, Marker, Circle, Popup,
    useMap, useMapEvents } from 'react-leaflet'
import { Icon } from 'leaflet'
import NoMap from '@components/map/NoMap'

// either import from library (not minified) or from cdn via Head component
// import 'leaflet/dist/leaflet.css'

import styles from 'styles/Map.module.css'

const TITLE_LAYER_ENDPOINT = 'https://{s}.tile.osm.org/{z}/{x}/{y}.png'
const OPEN_MAP_ENDPOINT = 'https://www.openstreetmap.org/'
const icon = new Icon({
    iconUrl: '/svg/pinezka.svg',
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [34, 54],
    iconAnchor: [17.5, 54],
    className: styles.icon
})

const ClientMap = ({ height = 400, coordinates = [19.25, 52.06], dragging = true, zoom = 6, popup = '', radius = '',
    onClick, style }) => {

    if (!coordinates || coordinates.length < 2) return <NoMap />

    const [lng, lat] = coordinates
    const digestibleCoordinates = [lat, lng]

    return (
        <div id="osm-map" style={{ height, ...(style || {}) }}>
            <Head>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/leaflet.min.css" />
            </Head>
            <MapContainer
                center={digestibleCoordinates}
                zoom={zoom}
                maxZoom={15}
                attributionControl={true}
                zoomControl={true}
                doubleClickZoom={true}
                scrollWheelZoom={false}
                dragging={dragging}
                animate={true}
                easeLinearity={0.35}
                onClick={onClick}
                className={styles.map}>

                <ChangeCenter center={digestibleCoordinates} />
                <TileLayer url={ TITLE_LAYER_ENDPOINT } className={styles.tiles} />
                <Marker icon={ icon } position={ digestibleCoordinates }>
                    <Popup>
                        <a href={ `${ OPEN_MAP_ENDPOINT }?mlat=${ lat }&mlon=${ lng }#map=12/${ lat }/${ lng }`} target="_blank" rel="noopener">{ popup } <i className="material-icons">open_in_new</i></a>
                    </Popup>
                </Marker>
                {
                    onClick && <ClickCollector onClick={onClick} />
                }
                {
                    radius && <Radius {...{ coordinates: digestibleCoordinates, radius }} />
                }
            </MapContainer>
        </div>
    )
}

function ChangeCenter ({ center }) {
    const map = useMap()
    map.flyTo(center, map.getZoom())
    return null
}

function ClickCollector ({ onClick }) {
    useMapEvents({
        click (e) {
            const { lat, lng } = e.latlng
            if (onClick) onClick([lng,lat])
        },

        // locationfound (location) {
        //     console.log(location)
        // }
    })

    return null
}

function Radius ({ coordinates, radius }) {
    return <Circle
      center={ coordinates }
      radius={ parseInt(radius * 1000) }
    />
}

export default ClientMap